import axios from 'axios';
import { MarkerHistoryResults } from 'features/markerHistory/types';

export async function getMarkerHistory(
  markersToGet: number[],
  snapshotId: string,
  begin: string,
  end: string
): Promise<MarkerHistoryResults> {
  const url = `/api/snapshots/${snapshotId}/marker-history/${begin}/${end}`;

  let params: {
    marker1?: number;
    marker2?: number;
    marker3?: number;
    marker4?: number;
  } = {};

  for (let i = 0; i < markersToGet.length; i++) {
    if (markersToGet[i] > -1) {
      params[
        `marker${i + 1}` as 'marker1' | 'marker2' | 'marker3' | 'marker4'
      ] = markersToGet[i];
    }
  }

  try {
    const { data } = await axios.get(url, {
      params: {
        ...params,
      },
    });
    return data as MarkerHistoryResults;
  } catch (err) {
    throw err;
  }
}
